<template>
    <div v-if="isActive" class="tab">
      <slot />
    </div>
  </template>
  
  <script>
  import { inject, onUnmounted, reactive, computed } from 'vue';
  
  export default {
    name: 'Tab',
    props: {
      title: {
        type: String,
        required: true
      }
    },
    setup(props) {
      const register = inject('tabs-register');
      const activeTabIndex = inject('active-tab-index');
      
      const tab = reactive({ title: props.title });
  
      const { isActive, unregister } = register(tab);
  
      onUnmounted(unregister);
  
      return { isActive: computed(() => isActive()) };
    }
  };
  </script>
  
  <style scoped>
  .tab {
    padding: 20px;
    border: 1px solid #ddd;
    border-top: none;
  }
  </style>
  